/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable arrow-body-style */
import {
 Autocomplete,
 CircularProgress,
 SxProps,
 TextField,
} from '@mui/material';
import { debounce } from '@mui/material/utils';
import { useState } from 'react';
import { Control, Controller, Path, UseFormSetValue } from 'react-hook-form';

import { get, post } from '../../api/api';
import { FormValues } from '../../types/types';
import { isJson } from '../../utils/dataTypes';

const SelectApi = <T extends FormValues = FormValues>({
 name,
 url,
 filter,
 label,
 isEditable,
 operator,
 control,
 setValue,
 multiple = false,
 disabled = false,
 isGet = false,
 styles,
}: {
 name: Path<T>;
 url: string;
 filter: string;
 label: string;
 isEditable?: boolean;
 operator: 'contains' | 'eq';
 control: Control<T, any>;
 setValue: UseFormSetValue<T>;
 multiple?: boolean;
 disabled?: boolean;
 isGet?: boolean;
 styles?: SxProps;
}) => {
 const [options, setOptions] = useState([]);
 const [loading, setLoading] = useState(false);
 const [inputValue, setInputValue] = useState('');
 const filterName = isJson(filter)
  ? JSON.parse(filter)?.fields?.split(',')[1]
  : 'Name';

 //  console.log(name, filter, url);

 const fetchOptions = async (val?: string) => {
  setLoading(true);
  try {
   const apiParams = JSON.parse(filter);

   const filtersData = val
    ? [
       ...(val
        ? [
           {
            field: filterName,
            operator,
            value: val,
            //  logic: 'And',
           },
          ]
        : []),
       ...(apiParams?.filters || []),
      ]
    : apiParams?.filters;
   if (Array.isArray(filtersData) && filtersData.length > 1) {
    filtersData[0].logic = 'And';
   }
   const response = await (isGet ? get : post)(url.replace('/api', ''), {
    ...apiParams,
    filters: filtersData,
   });
   setOptions(response.data || []);
  } catch (error) {
   console.error('Failed to load options:', error);
   setOptions([]);
  } finally {
   setLoading(false);
  }
 };

 return (
  control && (
   <Controller
    name={name}
    control={control}
    render={({ field }) => {
     //  console.log('selectApi field', field);
     return (
      <Autocomplete
       {...field}
       multiple={multiple}
       onOpen={() => {
        fetchOptions(inputValue);
       }}
       disabled={disabled || !isEditable}
       value={field.value || []}
       onChange={(_, value: any) => {
        // console.log('onChange', value, _);
        setValue(
         name,
         value || '',
         //   {
         //  shouldValidate: true,
         //  shouldDirty: true,
         // }
        );
       }}
       options={options}
       renderOption={(props, option) => (
        <li {...props} key={`${filterName}-${option[filterName]}-${option.Id}`}>
         {option[filterName]}
        </li>
       )}
       getOptionLabel={(option: any) => {
        return (
         options.find((o) => (o as any)?.Id === (option.Id || option))?.[
          filterName
         ] ||
         option?.[filterName] ||
         ''
        ).toString();
       }}
       filterOptions={(x) => x} // Disable client-side filtering
       onInputChange={debounce((_, val, reason) => {
        // console.log('onInputChange', reason, field.value, val);
        if (reason === 'reset') {
         return;
        }
        if (reason === 'clear') {
         setInputValue('');
         //  setValue('');
         //  clearValue();
         return;
        }

        if (field.value === val) return;
        setInputValue(val);
        if (reason !== 'reset') {
         fetchOptions(val);
        }

        // if (field.value[filterName] === value) return;
        // setInputValue(value);
        // fetchOptions(value);
       }, 500)}
       isOptionEqualToValue={(option, value) => {
        return (option as any).Id === value.Id;
       }}
       loading={loading}
       renderInput={(params) => (
        <TextField
         {...params}
         label={label}
         variant="outlined"
         disabled={disabled || !isEditable}
         sx={
          styles || {
           backgroundColor: 'transparent',
          }
         }
         //  slotProps={{
         //   input: {
         //    ...params.inputProps,
         //    sx: {
         //     // backgroundColor: 'white',
         //    },
         //   },
         //  }}
         InputProps={{
          ...params.InputProps,
          endAdornment: (
           <>
            {loading ? (
             <CircularProgress
              color="inherit"
              size={20}
              sx={{ pointerEvents: 'none' }}
             />
            ) : null}
            {params.InputProps.endAdornment}
           </>
          ),
         }}
        />
       )}
       sx={{ width: '100%' }}
      />
     );
    }}
   />
  )
 );
};
export default SelectApi;
